export default commomImport => [{
  path: `order-evaluation`,
  name: 'orderEvaluation',
  meta: {
    title: ('order.custEvaluate'),
    nameCount: 'evaluation'
  },
  //  全部订单
  component: commomImport('order-manager/order-evaluation')
}];
